export enum AppModes {
    MainScreen,
    SelectGameMode,
    Categories,
    Grid,
    Importing,
    Imported,
    About
}